<script>
  import News from 'src/pc/pages/News'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import PostContainer from '../components/PostContainer'
  import DropDown from '../components/Dropdown'
  export default {
    extends: News,
    components: {
      PageLayout,
      SubPageLayout,
      DisplayContainer,
      PostContainer,
      DropDown
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .contents {
    top: 0 !important;
  }
  .contents .display-container.title {
    width: 100vw;
    margin-bottom: 30px;
  }
  .contents .title_top {
    width: 100vw;
    height: 100px;
    padding: 20px;
    justify-content: center;
  }
  .contents .title_top:before {
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }
  .contents .title_top p {
    font-size: 34px;
  }
  .contents .crtn_top .title {
    font-size: 20px;
    font-weight: 900;
    line-height: 1.6em;
    margin: 15px 0;
  }
  .contents .crtn_top .title:before {
    width: 28px;
    height: 30px;
    margin-right: 8px;
  }
  .contents .crtn_top .sect {
    display: block;
    width: 100%;
  }
  .contents .crtn_top .sect.left {
    padding-right: 0;
    border-right: 0;
    margin-bottom: 15px;
  }
  .contents .crtn_top .sect.right {
    padding-left: 0;
  }
  .contents .crtn_top .sect .display-container .img {
    height: 58vw;
  }
  .contents .crtn_top .sect .display-container .img img {
    transform: translate(-62%, -50%);
  }
  .contents .crtn_top .sect .display-container .txt {
    height: 100%;
    background: linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,1.0) 50%);
    padding: 25px 20px 25px 25px;
  }
  .contents .crtn_top .sect .display-container .subj {
    font-size: 18px;
    margin-top: 0;
    color: #fff !important;
  }
  .contents .crtn_top .sect .display-container .category {
    font-size: 12px;
    margin-top: 10px;
    line-height: 1.2em;
    right: 20px;
    bottom: 25px;
  }
</style>
